import React, { Component } from 'react';

import i18n from 'i18n-react';
import { storageKeys } from 'config/settings.json';

import { ContentHeader } from 'components/ContentHeader/ContentHeader';
import FavoriteLink from 'components/FavoriteLink';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

export default class FavoriteView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      favorites: [],
    };
  }

  UNSAFE_componentWillMount() {
    this.setFavorites();
  }

  setFavorites() {
    return DataHandler.matchAppId().then((appId) => {
      return StorageHandler.load(storageKeys.user).then((user) => {
        return StorageHandler.load(storageKeys.lang).then(({ code }) => {
          APIHandler.getFavorite(appId, user.email, {
            message: 'Called from FavoriteView.js',
          }).then((favorites) => {
            StorageHandler.save(storageKeys.favorites, favorites);
            const favoriteArray = [];
            const favoriteContent = [];
            favorites.data.forEach((el) => {
              favoriteContent.push(el);
            });
            APIHandler.getFavoriteContent(favoriteContent, code).then((res) => {
              if (res && res.pages) {
                res.pages.forEach((info, index) => {
                  const key = index;
                  favoriteArray.push(
                    <FavoriteLink
                      info={info}
                      favorites={favorites}
                      contentInfo={favoriteContent[key]}
                      key={`fav_${key}`}
                    />,
                  );
                });
                this.setState({ favorites: favoriteArray });
              }
            });
          });
        });
      });
    });
  }

  render() {
    return (
      <div className="contentContainer favoriteView">
        <ContentHeader
          header={i18n.translate('nav.favorites')}
          subtitle={i18n.translate('pageDescriptions.favorites')}
          pageHeader
        />
        <div className="favorite__Container">
          {this.state.favorites.length === 0 && <p className="subtitle">{i18n.translate('general.noFavorites')}</p>}
          <div className="favorite__Grid">{this.state.favorites}</div>
        </div>
      </div>
    );
  }
}
